export default __webpack_public_path__ + "static/avatar-kortical-team2--mobile-d8fa2770f4313b536b5cdabb975b4882.webp";